import React from 'react';
import Imglogo from '../../assets/img/SYNAMATIC.png';
const Footer = () => {
    return (
        <div>
            <footer>
                <div class="m20">
                    <hr />
                    <img src={Imglogo} alt="" />
                </div>
            </footer>
        </div>
    );
};

export default Footer;
